import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import BoxLayoutContent from "@/shared/components/layout/boxLauotContent";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import UserMessagesTable from './tableMessage';

const Message = () => {
  return (
    <BoxLayoutContent
      titleElement={
        <StackKit direction={"row"} gap={2}>
          <TypoGraphyKit variant="h6">
            <EmailOutlinedIcon />
          </TypoGraphyKit>
          <TypoGraphyKit variant="h6"> پیام های </TypoGraphyKit>
        </StackKit>
      }
    >
      <UserMessagesTable />
    </BoxLayoutContent>
  );
};

export default Message;
